// extracted by mini-css-extract-plugin
module.exports = {"modal":"account-about_modal__uxOrz"};